module.exports = __webpack_public_path__ + "img/android_qr_code.5f710afb.png";